<div class="headline" [class.expanded]="expanded">
  <span class="label">{{headline}}</span>
</div>
